import React, { Component } from 'react';
import { Col,  FormControl } from 'react-bootstrap';

/**
* Class TextFilter
* Generic component to generate text filters
**/
class NumFilter extends Component {
  /**
  * props
  * title : title of the field
  * name : reference name prefix
  * parentFilter : parent filter reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.handleNumChange = this.handleNumChange.bind(this);
    this.state = {
      valueInf: "",
      valueSup: "",
    };
  }

  /**
  * render
  * Rendering component function : display the text filter
  **/
  render() {
    const textfieldProps = {
      type: "text",
      onChange: this.handleNumChange,
      ref: "textfield",
      value: this.state.valueInf,
      id: this.props.name,
      placeholder: this.props.title
    };

    // Form rendering
    return(
      <Col componentClass="filterTextField" sm={2}><FormControl {...textfieldProps} /></Col>
    );

    // return(
    //   <FormGroup>
    //     <Col componentClass="filterTextLabel" sm={2}><ControlLabel>{this.props.title}</ControlLabel></Col>
    //     <Col componentClass="filterTextField" sm={2}><FormControl {...textfieldProps} /></Col>
    //   </FormGroup>
    // );
  }

  /**
  * handleChange
  * Call the handleChange of the parent
  **/
  handleNumChange(e) {
    const value = e.target.value
    //this.setState({value: value});
    //this.props.parentFilter.handleNumChange(this, value);

    this.setState({
      ...this.state,
      valueInf: value,
      valueSup: value,
    });
    this.props.parentFilter.handleNumChange(this, {valueInf:value, valueSup: value});
  }

  /**
  * reset
  * Reset the value
  **/
  reset() {
    this.setState({
      ...this.state,
      valueInf: "",
      valueSup: "",
    });
  }

}

export default NumFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/NumFilter.js